import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSpeciality } from "../../../../api/axios";
import ENDPOINTS from "../../../../api/endpoints";

const errorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

export const fetchNephrologyHistory = createAsyncThunk(
  "nephrology/fetchHistory",
  async (patientId, { rejectWithValue }) => {
    try {
      const cleanPatientId = String(patientId || "").trim();
      if (!cleanPatientId) throw new Error("patientId is required");

      const { data } = await axiosSpeciality.get(
        ENDPOINTS.SPECIALITY.NEPHROLOGY.HISTORY_BY_PATIENT(cleanPatientId)
      );
      const records = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
      return { patientId: cleanPatientId, records };
    } catch (error) {
      return rejectWithValue(errorMessage(error, "Unable to load nephrology history"));
    }
  }
);

export const saveNephrologyHistory = createAsyncThunk(
  "nephrology/saveHistory",
  async ({ patientId, historyId, values }, { rejectWithValue }) => {
    try {
      const cleanPatientId = String(patientId || "").trim();
      if (!cleanPatientId) throw new Error("patientId is required");

      const response = historyId
        ? await axiosSpeciality.patch(
            ENDPOINTS.SPECIALITY.NEPHROLOGY.HISTORY_BY_ID(historyId),
            values
          )
        : await axiosSpeciality.post(
            ENDPOINTS.SPECIALITY.NEPHROLOGY.HISTORY_BY_PATIENT(cleanPatientId),
            values
          );

      return { patientId: cleanPatientId, record: response.data };
    } catch (error) {
      return rejectWithValue(errorMessage(error, "Unable to save nephrology history"));
    }
  }
);

export const fetchNephrologyExam = createAsyncThunk(
  "nephrology/fetchExam",
  async (patientId, { rejectWithValue }) => {
    try {
      const cleanPatientId = String(patientId || "").trim();
      if (!cleanPatientId) throw new Error("patientId is required");

      const { data } = await axiosSpeciality.get(
        ENDPOINTS.SPECIALITY.NEPHROLOGY.EXAM_BY_PATIENT(cleanPatientId)
      );
      const records = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
      return { patientId: cleanPatientId, records };
    } catch (error) {
      return rejectWithValue(errorMessage(error, "Unable to load nephrology exam"));
    }
  }
);

export const saveNephrologyExam = createAsyncThunk(
  "nephrology/saveExam",
  async ({ patientId, examId, values }, { rejectWithValue }) => {
    try {
      const cleanPatientId = String(patientId || "").trim();
      if (!cleanPatientId) throw new Error("patientId is required");

      const response = examId
        ? await axiosSpeciality.patch(
            ENDPOINTS.SPECIALITY.NEPHROLOGY.EXAM_BY_ID(examId),
            values
          )
        : await axiosSpeciality.post(
            ENDPOINTS.SPECIALITY.NEPHROLOGY.EXAM_BY_PATIENT(cleanPatientId),
            values
          );

      return { patientId: cleanPatientId, record: response.data };
    } catch (error) {
      return rejectWithValue(errorMessage(error, "Unable to save nephrology exam"));
    }
  }
);

export const fetchNephrologyUrinaryAndUremia = createAsyncThunk(
  "nephrology/fetchUrinaryAndUremia",
  async (patientId, { rejectWithValue }) => {
    try {
      const cleanPatientId = String(patientId || "").trim();
      if (!cleanPatientId) throw new Error("patientId is required");

      const { data } = await axiosSpeciality.get(
        ENDPOINTS.SPECIALITY.NEPHROLOGY.URINARY_UREMIA_BY_PATIENT(cleanPatientId)
      );
      const records = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
      return { patientId: cleanPatientId, records };
    } catch (error) {
      return rejectWithValue(errorMessage(error, "Unable to load urinary and uremia data"));
    }
  }
);